define([
    'vue',
    'web/i18n/index',
    'vueRouter',
    'index2021-cooperate/component/page-content',
    'web/common/mixin/page',

    'css!index2021-cooperate/index2021-cooperate.css'
], function(
    Vue,
    i18n,
    VueRouter,
    PageContent,
    PageMixin
){
    Vue.use(VueRouter);

    var routes = [
        { path: '*', component: PageContent }
    ];
    var router = new VueRouter({
        routes: routes,
        mode: 'history',
        base: '/'
    });

    var app = new Vue({
        mixins: [PageMixin],
        router: router,
        i18n: i18n
    });
    app.$mount('#app');
});


//////////////////
// WEBPACK FOOTER
// ./index2021-cooperate/main.js
// module id = 199
// module chunks = 0